import type { SelectOption, SelectOptionGroup } from 'contracts/Common';
import type { WarehouseBuilding } from 'contracts/WarehouseBuildings';

const formatCondition = (condition: string): string =>
  `${condition.charAt(0)}${condition.slice(1).toLocaleLowerCase('pt-BR')}`;

const toOption = (building: WarehouseBuilding): SelectOption => ({
  value: building.id,
  label: building.condition
    ? `${building.name} - ${formatCondition(building.condition)}`
    : building.name,
});

export const groupBuildingsByArea = (
  buildings: WarehouseBuilding[]
): SelectOptionGroup[] =>
  buildings.reduce<SelectOptionGroup[]>((groups, building) => {
    const existing = groups.find((group) => group.label === building.area.name);

    if (!existing) {
      return [
        ...groups,
        { label: building.area.name, options: [toOption(building)] },
      ];
    }

    return groups.map((group) =>
      group.label === building.area.name
        ? { ...group, options: [...group.options, toOption(building)] }
        : group
    );
  }, []);

export const findBuildingOption = (
  buildings: WarehouseBuilding[],
  buildingId: number | null | undefined
): SelectOption | null => {
  if (!buildingId) return null;

  const building = buildings.find(({ id }) => id === buildingId);
  return building ? toOption(building) : null;
};
